export const WorkArchive = ({ allPosts, allQuotes, allImages, categoryChoices }) => {
  return {
    allPosts,
    allQuotes,
    allImages,
    allCards: undefined,
    filteredCards: [],
    cardsToShow: [],
    categoryChoices,
    chosenCategory: false,
    endReached: false,
    postsPerPage: 20,
    cardsDisplayed: 20,
    mounted() {
      // Get all posts/quotes/images
      const posts = this.allPosts;
      const quotes = this.allQuotes;
      const images = this.allImages;
      let i;

      // determine positions of quotes
      let quotePositions = [];
      let newQuotePos = 0;
      for (i = 0; i < quotes.length; i++) {
        newQuotePos = Math.floor(Math.random() * (11 - 6 + 1) + 6) + newQuotePos;
        quotePositions.push(newQuotePos);
      }

      // dertermine positions of images
      let minPos;
      let maxPos;
      let newImagePos = 0;
      let currentImage = 0;
      let imagePositions = [];
      for (i = 0; i < posts.length / 12; i++) {
        // Get minimum position
        if (quotePositions.length > i) {
          minPos = quotePositions[i] + 2;
        } else if (minPos > 2) {
          minPos = minPos + 6;
        } else {
          minPos = 2;
        }

        // Get maximum position
        if (quotePositions.length > i + 1) {
          maxPos = quotePositions[i + 1] - 2;
        } else if (maxPos > 11) {
          maxPos = maxPos + 6;
        } else {
          maxPos = 11;
        }
        newImagePos = Math.floor(Math.random() * (maxPos - minPos + 1) + minPos);
        imagePositions.push(newImagePos);
      }

      // Create new array to push all cards into
      let cards = [];

      // Loop through and push into cards array.
      for (i = 0; i < posts.length; i++) {
        // add quotes if they match the spot.
        for (let q = 0; q < quotePositions.length; q++) {
          if (quotePositions[q] == i) {
            cards.push(quotes[q]);
          }
        }

        // add images if they match the spot.
        for (let f = 0; f < imagePositions.length; f++) {
          if (imagePositions[f] == i) {
            currentImage = f + 1 == images.length ? 0 : f;
            cards.push(images[currentImage]);
          }
        }

        // Add Posts
        cards.push(posts[i]);
      }

      this.allCards = cards;
      this.filteredCards = cards;

      // Can't use paginate function on mount, so have to rewrite, slightly different.
      // Check if we're at the end of the posts, and add them to the cards array.
      let cardsToShow = [];
      if (this.allCards.length < this.cardsDisplayed) {
        cardsToShow = this.allCards;
        this.endReached = true;
      } else {
        this.endReached = false;

        for (let i = 0; i < this.cardsDisplayed; i++) {
          cardsToShow.push(this.allCards[i]);
        }
      }
      this.cardsToShow = cardsToShow;
    },
    paginate() {
      // ensure there are filtered cards
      if (this.filteredCards.length === 0) {
        this.filteredCards = this.allCards;
      }

      if (this.filteredCards.length < this.cardsDisplayed) {
        this.cardsToShow = this.filteredCards;
        this.endReached = true;
      } else {
        this.endReached = false;

        let cardsToShow = [];
        for (let i = 0; i < this.cardsDisplayed; i++) {
          cardsToShow.push(this.filteredCards[i]);
        }
        this.cardsToShow = cardsToShow;
      }
    },
    filterPosts(categorySlug = false) {
      // reset cards displayed to the first paginated set.
      this.cardsDisplayed = this.postsPerPage;

      // No Category Selected
      if (categorySlug == false) {
        this.filteredCards = this.allCards;
        this.chosenCategory = false;
        this.paginate();
      }
      // Filter by Category
      else {
        this.chosenCategory = categorySlug;

        let items = [];
        items = this.allCards.filter((l) => {
          // filter by category
          if (l.cardType == "post" && l.category.slug == categorySlug) {
            return true;
          }

          return false;
        });

        this.filteredCards = items;
        this.paginate();
      }
    },
    loadMore() {
      // Get the number of cards to display
      this.cardsDisplayed = this.cardsDisplayed + this.postsPerPage;
      this.paginate();
    },
  };
};
